import Pagination from '@mui/material/Pagination';
import React, { useState } from 'react';
import Columns from './Columns';
import Rows from './Rows';
import AuditRows from './Rows';


interface ILibTableProps {
    cases: any;
    setCases: any;
    handlePageChange: any;
    pageNum: number;
    total: number;
    setSearchVal: any;
    trigger: boolean;
    setTrigger: any;
    setSelectedCase: any;
    setShareModal: any;
    userHasMonitor: boolean;
}

interface AutomationType {
  name: string;
  type: string;
  lastUpdated: string;
  status: string;
}

const MonitorTicketTable: React.FC<ILibTableProps> = (props: ILibTableProps) => {
  const { cases, setCases, handlePageChange, pageNum, total, trigger, setTrigger, setSelectedCase, setShareModal, userHasMonitor } = props;

  const [ sortConfig, setSortConfig ] = useState<{ key: keyof AutomationType; direction: 'asc' | 'desc' }>({
    key: 'name',
    direction: 'asc',
  });

  // Sorting function
  const sortData = (key: string) => {
    // Type assertion to ensure the key is one of the allowed keys
    if ([ 'name', 'type', 'lastUpdated', 'status' ].includes(key)) {
      const typedKey = key as keyof AutomationType;
      const sortedData = [ ...cases ];

      if (sortConfig.key === typedKey && sortConfig.direction === 'asc') {
        sortedData.sort((a, b) => (a[typedKey] > b[typedKey] ? -1 : 1));
        setSortConfig({ key: typedKey, direction: 'desc' });
      } else {
        sortedData.sort((a, b) => (a[typedKey] > b[typedKey] ? 1 : -1));
        setSortConfig({ key: typedKey, direction: 'asc' });
      }
      setCases(sortedData);
    }
  };


  return (
    <div className={`library-cont ${!userHasMonitor ? 'os-iframe-blur' : ''}`}>
      <div className='screening-results-container'>
        <div className='library-cont-table-head'>
          <div className='library-cont-table-header'>
            <div className='library-cont-table-header-cont'>
              <div className='library-cont-table-header-cont-text'>
                <h1>Tickets</h1>
                <div className='library-cont-table-header-cont-text-card'>
                  <p>{total} total</p>
                </div>
              </div>
            </div>
          </div>
        </div>


        { cases.length > 0 ? (
          <>
            <Columns sortData={sortData} sortConfig={sortConfig}/>
            <div className='screening-results-table-container'>
              {cases.map((row: any, index: number) => (
                <AuditRows
                  key={index}
                  ticket={row}
                  trigger={trigger}
                  setTrigger={setTrigger}
                  setSelectedCase={setSelectedCase}
                  setShareModal={setShareModal}
                />
              ))}
            </div>
          </>
        ) : (
          <><Columns sortData={sortData} sortConfig={sortConfig} />
            <div className='screening-results-table-container'>
            </div>
          </>
        )}

        <div className='screening-results-footer'>
          <div className='screening-results-pagination-text'>
          Page {pageNum} of {Math.max(1, Math.ceil(total / 10))}
          </div>
          <div className='screening-results-footer-action-group'>
            <div className='hb-pagination'>
              <Pagination
                onChange={handlePageChange}
                size='large'
                count={Math.max(1, Math.ceil(total / 10))}
                shape='rounded'
                variant='text'
                page={pageNum}
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default MonitorTicketTable;
